export default __webpack_public_path__ + "static/7-invert-69db974fcde30c128479aab48e4a52ae.png";